"use client";

import { useState } from "react";
import ThemeAwareLogo from "@/components/theme-aware-logo";
import { ModeToggle } from "@/components/mode-toggle";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { content } from "@/data/content";

export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/50 backdrop-blur-md border-b border-transparent hover:border-border/30 transition-colors duration-300">
      <div className="container mx-auto px-4 py-2 flex justify-between items-center">
        <a href="#inicio" aria-label="Ir al inicio de SoloSolar">
          <ThemeAwareLogo />
        </a>
        <div className="flex items-center space-x-6">
          <nav
            className="hidden md:flex items-center space-x-7"
            aria-label="Navegación principal"
          >
            {content.nav.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-base font-medium tracking-wide transition-all duration-300 hover:text-[#76CBCA]"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <div className="hidden lg:block">
            <Button asChild size="sm">
              <a href="#contacto">{content.navCta}</a>
            </Button>
          </div>
          <ModeToggle />
          <button
            type="button"
            className="md:hidden inline-flex items-center justify-center rounded-md p-2 text-muted-foreground hover:bg-accent hover:text-foreground transition-colors"
            onClick={() => setIsMenuOpen((open) => !open)}
            aria-expanded={isMenuOpen}
            aria-controls="mobile-menu"
            aria-label="Abrir o cerrar menú de navegación"
          >
            {isMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div id="mobile-menu" className="md:hidden border-t border-border/30">
          <nav
            className="container mx-auto px-4 py-4 flex flex-col gap-1"
            aria-label="Navegación móvil"
          >
            {content.nav.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={closeMenu}
                className="py-2 text-base font-medium tracking-wide transition-all duration-300 hover:text-[#76CBCA]"
              >
                {item.label}
              </a>
            ))}
            <a href="#contacto" onClick={closeMenu} className="py-2">
              <Button asChild size="sm" className="w-full">
                <span>{content.navCta}</span>
              </Button>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
